var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ee-progress",
    style: (("width: " + _vm.width + "px;"))
  }, [(_vm.value > 0) ? _c('div', {
    staticClass: "ee-progress__bar",
    style: (("width: " + _vm.value + "%"))
  }, [_vm._v(_vm._s(_vm.value) + "%")]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45479d89","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/progess/ProgressBar.vue
// module id = 564
// module chunks = 13